<template>

  <b-row>
    <b-col md="12">
      <b-card no-body :class="{ open: visibleBody }">
        <b-card-header :class="{ collapsed: !visibleBody }" :aria-expanded="visibleBody ? 'true' : 'false'" role="tab"
          data-toggle="collapse" @click="() => visibleBody = !visibleBody"
          style="padding: 1rem; background-color: #0080C9; color: white; font:45px; padding:15px;  ">
          <span class="lead collapse-title">
            <strong>EVOLUCION PACIENTE</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="padding:1.5rem">
            <b-card>

              <b-table :items="items" :fields="fields" bordered striped>
                <template #cell(acciones)="data">
                  <div class="d-flex justify-content-center">

                    <b-button variant="primary" size="sm" @click="viewItem(data.item)">
                      <i class="fas fa-stethoscope"></i>

                    </b-button>
                    <b-button v-if="data.item.laboratorios && data.item.laboratorios.length > 0" variant="warning" size="sm" @click="viewLabs(data.item)">
                      <i class="fas fa-flask"></i>
                     

                    </b-button>
                    <b-button v-if="data.item.imagenes && data.item.imagenes.length > 0" variant="info" size="sm" @click="viewImagenes(data.item)">
                      <i class="fas fa-image"></i>

                    </b-button>

                  </div>
                </template>
              </b-table>
            </b-card>
            <b-modal id="modal-detalles-diagnosticos">
              <b-card>
                <b-row>
                  <b-col>
                    <h4>Diagnosticos: </h4>
                  </b-col>
                  <b-table :items="itemsdiagnosticos" :fields="fieldsdiagnosticos" bordered striped>
                  </b-table>
                </b-row>
              </b-card>
            </b-modal>
            <b-modal id="modal-detalles-laboratorios" size="lg">
              <b-card>
                <b-row>
                  <b-col>
                    <h4>Laboratorios: </h4>
                  </b-col>
                  <b-table :items="itemlab" :fields="fieldslaboratorio" bordered striped>
                    <template #cell(codigo)="data">
                      {{ data.item.laboratorio.codigo }}
                    </template>
                    <template #cell(descripcion)="data">
                      {{ data.item.laboratorio.descripcion }}
                    </template>
                  </b-table>
                </b-row>
              </b-card>
            </b-modal>
            <b-modal id="modal-detalles-imagenes" size="xl">
              <b-card>
                <b-row>
                  <b-col>
                    <h4>Imagenes: </h4>
                  </b-col>
                  <b-table :items="itemimg" :fields="fieldsimagenes" bordered responsive striped>
                    <template #cell(codigo)="data">
                      {{ data.item.imagen.codigo }}
                    </template>
                    <template #cell(nombre)="data">
                      {{ data.item.imagen.nombre }}
                    </template>
                    <template #cell(tipoimagen)="data">
                      {{ data.item.imagen.tipoImagen.descripcion }}
                    </template>
                   
                  </b-table>
                </b-row>
              </b-card>
            </b-modal>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>


</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { mapState } from 'vuex';
export default {

  name: "EvolucionPaciente",

  components: {

  },
  props: {
    idPaciente: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: null // Valor por defecto si no se proporciona
    },


  },

  data() {
    return {
      itemsdiagnosticos: [],
      fieldsdiagnosticos: [
        { key: "codigo", label: "codigo", thClass: "text-center" },
        { key: "diagnostico", label: "diagnostico", thClass: "text-center" },

      ],
      visibleBody: false,
      items: [],
      fields: [
        { key: "fecha", label: "Fecha", thClass: "text-center" },
        { key: "doctor", label: "Doctor", thClass: "text-center" },
        { key: "problema", label: "Problema Actual", thClass: "text-center" },
        { key: "acciones", label: "Acciones", thClass: "text-center" },

      ],
      fieldslaboratorio: [
        { key: "norden", label: "NumOrden", thClass: "text-center" },
        { key: "codigo", label: "Codigo", thClass: "text-center" },
        { key: "descripcion", label: "Descripcion", thClass: "text-center" },
       

      ],
      fieldsimagenes: [
      { key: "norden", label: "NumOrden", thClass: "text-center" },
        { key: "codigo", label: "Codigo", thClass: "text-center" },
        { key: "nombre", label: "Descripcion", thClass: "text-center" },
        { key: "tipoimagen", label: "Tipo Imagen", thClass: "text-center" },
        { key: "motivo", label: "Motivo", thClass: "text-center" },
        { key: "resumen", label: "Resumen Clinico", thClass: "text-center" },
       
       

      ],
      paciente: {
        nombre: "",
        cedula: "",
        edad: "",
        ocupacion: "",
      },
      doctor: {
        nombre: "",
        especialidad: "",
      },
      cita: {
        fecha: "",
        hora: "",
      },

      itemselected: null,
      itemlab : [],
      itemimg : [],



    };
  },
  created() {

  },

  methods: {

    async viewItem(itemselected) {

      this.itemselected = itemselected
      if (itemselected.diagnosticos.length > 0) {
        this.itemsdiagnosticos = itemselected.diagnosticos
      }
      else {
        this.itemsdiagnosticos = [{
          codigo: "",
          diagnostico: "Sin diagnostico"
        }]
      }
      this.$bvModal.show("modal-detalles-diagnosticos");
    },
    async buscarLaboratoriosIds(ids) {
            const query = `query MyQuery($ids : [ID]) {
                    getLaboratorios(ids:$ids) {
                        codigo
                        descripcion
                        id
                    }
                    }`;
            const variables = {
                ids: ids
            }
            try {
                const response = await axios.post(rutas.axios + 'api', { query, variables });
                if (response.data.data.getLaboratorios) {
                    let laboratorios = response.data.data.getLaboratorios
                    return laboratorios
                }
            } catch {

            }
        },
    async viewLabs(itemselected) {

      this.itemselected = itemselected
      
      if (itemselected.laboratorios && itemselected.laboratorios.length > 0) {
        
        let laboratoriostable = []

        itemselected.laboratorios.forEach(async (item) => { console.log(item.idlaboratorios)

          let laboratorios = await this.buscarLaboratoriosIds(item.idlaboratorios)
          if (laboratorios.length > 0){
            laboratorios.forEach(elemento => {
              laboratoriostable.push({norden : item.norden, laboratorio : elemento})
            })
          }
          
        })
        
        
        this.itemlab = laboratoriostable
      }
      else {
        this.itemlab = []
      }
      this.$bvModal.show("modal-detalles-laboratorios");
    },
    async viewImagenes(itemselected) {

      this.itemselected = itemselected
      if (itemselected.imagenes.length > 0) {
        this.itemimg = itemselected.imagenes
      }
      else {
        this.itemimg = []
      }
      this.$bvModal.show("modal-detalles-imagenes");
    },

    async fetchCitaPaciente() {
      const query = `query MyQuery($idPaciente: ID, $codesp: String) {
  allCitasIdPaciente(idPaciente: $idPaciente, codesp: $codesp) {
    message
    status
    total
    cita {
      anamnesisSet {
        id
        problemaActual
      }
      cita {
      id
        doctor {
          idPersona {
            primerNombre
            primerApellido
          }
        }
        signosvitalSet {
          freqRespiratoria
          id
          estadoSignosvital
          imc
          perimetroAbdominal
          perimetroCefalico
          peso
          pulso
          satOxigeno
          talla
          temperatura
          tensionArterialDiastolica
          tensionArterialSistolica
        }
      }
      id
      fechaCreacion
      diaganamSet {
        diagnostico {
          codigo
          descripcion
        }
        esprincipal
        fechaCreacion
      }
      envioimagenSet {
        motivoSolicitud
        resumenClinico
        numeroOrdenAs400
        imagen {
          codigo
          nombre
          tipoImagen {
            descripcion
          }
        }
      }
      estudiolabSet {
        LabAs400 {
          numeroOrden
          idslaboratorios
        }
      }
      exafisanamSet {
        id
      }
      recetaSet {
        medicamentosRecetados {
          dosis
          cantidad
          duracion
          observacion
          medicamento {
            codigo
            nombre
          }
        }
      }
    }
  }
}`;
      const variables = {
        idPaciente: this.idPaciente,
        codesp: this.doctor.especialidad
      }
      try {
        const response = await axios.post(rutas.axios + 'api', {
          query: query,
          variables: variables
        });
        const respuesta = response.data.data.allCitasIdPaciente

        if (respuesta && respuesta.cita && respuesta.cita.length > 0) {
          let citas = respuesta.cita;



          for (let i = 0; i < citas.length && i < 10; i++) {

            if (citas[i]) {
              let signosvitales = []
              let diagnosticos = []
              let imagenes = []
              let laboratorios = []

              const fechaISO = citas[i].fechaCreacion;
              const dateObj = new Date(fechaISO);
              const dia = dateObj.getDate().toString().padStart(2, '0');
              const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0');
              const anio = dateObj.getFullYear();
              const fechaFormateada = `${dia}-${mes}-${anio}`;

              if (citas[i].cita.signosvitalSet.length > 0) {
                signosvitales = citas[i].cita.signosvitalSet[0]
              }
              let diagnosticostable = []
              if (citas[i].diaganamSet.length > 0) {

                diagnosticos = citas[i].diaganamSet
                diagnosticos.forEach(diag => {

                  diagnosticostable.push({
                    codigo: diag.diagnostico.codigo,
                    diagnostico: diag.diagnostico.descripcion

                  })
                })

              }
              let imagenestable = []
              if (citas[i].envioimagenSet.length > 0) {
                imagenes = citas[i].envioimagenSet
                imagenes.forEach(img => {
                  imagenestable.push({
                    norden : img.numeroOrdenAs400,
                    imagen : img.imagen,
                    motivo : img.motivoSolicitud,
                    resumen :img.resumenClinico
                  })
                })
                
              }
              let laboratoriostable = []
              if (citas[i].estudiolabSet.length > 0) {
                laboratorios = citas[i].estudiolabSet
                laboratorios.forEach(lab => {
                  if(lab.LabAs400 && lab.LabAs400.length > 0){
                    lab.LabAs400.forEach(item => {
                      let newArrayLabs = item.idslaboratorios.split(',').map(item => item.trim());
                      laboratoriostable.push({norden: item.numeroOrden , idlaboratorios : newArrayLabs})
                      
                    })
                  }
                })
                }
              
              let problemaActual = "No disponible"
              if (citas[i].anamnesisSet.length > 0) {
                problemaActual = citas[i].anamnesisSet[0].problemaActual
              }



              this.items.push({
                fecha: fechaFormateada,
                doctor: `${citas[i].cita.doctor.idPersona.primerNombre} ${citas[i].cita.doctor.idPersona.primerApellido}`,
                problema: problemaActual,

                signos: signosvitales,
                diagnosticos: diagnosticostable,
                imagenes: imagenestable,
                laboratorios: laboratoriostable

              })
            }
          }


        }

      } catch (error) {
        console.error("Error fetching ultimas citas", error);
      }
    },

    async loadDataCita() {

      if (!this.dataAtencionMedica) return;

      this.paciente.nombre = `${this.dataAtencionMedica?.paciente.persona.primerApellido} ${this.dataAtencionMedica?.paciente.persona.primerNombre}`;
      this.paciente.cedula = this.dataAtencionMedica?.paciente.persona.identificacion;
      this.paciente.ocupacion = this.dataAtencionMedica?.paciente.persona.ocupacion?.descripcion;
      this.doctor.nombre = `${this.dataAtencionMedica?.doctor.idPersona.primerApellido} ${this.dataAtencionMedica?.doctor.idPersona.primerNombre}`;
      this.doctor.especialidad = this.dataAtencionMedica?.doctor.especialidad.codEsp;
      this.cita.fecha = this.dataAtencionMedica?.fechaCita;
      this.cita.hora = this.dataAtencionMedica?.horaCita;
    }


  },



  watch: {

    dataAtencionMedica: {
      async handler() {
        await this.loadDataCita()
        await this.fetchCitaPaciente()

      },
      deep: true,
    }
  },
  computed: {
    ...mapState({
      dataAtencionMedica: state => state.atencionCita.dataCita
    }),
  },



};
</script>
